import React, { useState } from 'react';
import { CreateReleaseOverlay, ReleaseList } from 'app/components/Releases';
import { ChakraPageTitle } from 'app/components/Core';
import { ContentContainerType } from 'types/enums';
import { ContentContainer } from 'app/components/Core/ChakraContentContainer';

export const Releases = () => {
  const [overlayOpen, setOverlayOpen] = useState(false);

  const openOverlay = () => setOverlayOpen(true);

  const closeOverlay = () => {
    setOverlayOpen(false);
  };

  return (
    <ContentContainer
      type={ContentContainerType.LIST}
      isViewContent
      paddingTop={6}
    >
      <ChakraPageTitle mb={2}>Releases</ChakraPageTitle>
      <ReleaseList />
      <CreateReleaseOverlay
        open={overlayOpen}
        onOpen={openOverlay}
        onClose={closeOverlay}
      />
    </ContentContainer>
  );
};
